// removed by extract-text-webpack-plugin
module.exports = {"h1":"H1__h1"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/typography/H1/H1.desktop.css
// module id = 1353
// module chunks = 8